import { Link } from "react-router-dom";
import Icon from "./Icon";
import s from "./CarGridState.module.css";

/** Loading / error / empty states around a car grid; renders children when there is something to show. */
export default function CarGridState({ status, count, emptyText, onReset, children }) {
  if (status === "loading") {
    return (
      <div className={s.skeletons} aria-busy="true" aria-label="Načítám vozy">
        {[0, 1, 2].map((i) => <div key={i} className={s.skeleton} />)}
      </div>
    );
  }
  if (status === "error") {
    return (
      <div className={s.box} role="alert">
        <Icon name="alert-circle" size={28} />
        <p>Nabídku se nepodařilo načíst. Zkuste stránku obnovit, nebo nám zavolejte.</p>
      </div>
    );
  }
  if (count === 0) {
    return (
      <div className={s.box}>
        <Icon name="car" size={28} />
        <p>{emptyText || "Momentálně nemáme žádný vůz skladem. Rádi vám ho najdeme a dovezeme na míru."}</p>
        {onReset
          ? <button type="button" className="btn btn-ghost" onClick={onReset}>Zrušit filtry</button>
          : <Link to="/dovoz" className="btn btn-primary">Poptat dovoz na míru</Link>}
      </div>
    );
  }
  return children;
}
